import { Component, HostListener, Inject, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CommonWebService, SnackbarEnum } from "apps/website/src/app/utils/public-api";

@Component({
  selector: "intrasense-importcsv-dialog",
  templateUrl: "./importcsv-dialog.component.html",
  styleUrls: ["./importcsv-dialog.component.scss"],
})
export class ImportcsvDialogComponent implements OnInit {
  title!: string;
  fileCtrl = new FormControl("");
  uploadedCsv!: any;
  submitAttempted: boolean = false;
  constructor(
    private dialogRef: MatDialogRef<ImportcsvDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string, private commonWebService: CommonWebService
  ) {
    if (this.data) {
      this.title = this.data ? this.data : '';
    }
  }
  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    if (event.target.innerWidth > 1200) {
      this.dialogRef.updateSize("40%");
    } else {
      this.dialogRef.updateSize("100%");
    }
  }

  ngOnInit(): void {
    if (window.innerWidth > 1200) {
      this.dialogRef.updateSize("40%");
    } else {
      this.dialogRef.updateSize("100%");
    }
  }

  uploadCSV() {
    if (this.fileCtrl.value && this.uploadedCsv) {
      this.close(this.uploadedCsv);
    } else {
      this.submitAttempted = true;
      return;
    }
  }

  async onUploadFile(event: any, isDrag: boolean = false) {
    if ((isDrag && event && event[0]) || (!isDrag && event && event.target && event.target.files && event.target.files[0])) {
      if ((isDrag && event[0].type && event[0].type == 'text/csv') || (!isDrag && event && event.target && event.target.files && event.target.files[0] && event.target.files[0].type && event.target.files[0].type == 'text/csv')) {
        let file = isDrag ? event[0] : event.target.files[0];
        this.uploadedCsv = file;
        const result = await new Promise((resolve, reject) => {
          let reader = new FileReader();
          reader.addEventListener(
            "load",
            function () {
              resolve(reader.result);
            },
            false
          );
          reader.onerror = () => {
            return reject(this);
          };
          reader.readAsDataURL(file);
        });
        this.fileCtrl.setValue(result);
      } else {
        this.commonWebService.openSnackbar("File type not supported", SnackbarEnum.ERROR);
      }
    }
  }

  previewImage() {
    window.open(this.fileCtrl.value ? this.fileCtrl.value : '');
  }

  removeImage() {
    this.fileCtrl.setValue("");
    this.uploadedCsv = '';
  }

  close(value?: any) {
    document
      .getElementsByClassName("animate__animated")[0]
      .classList.remove("animate__fadeInUp");
    document
      .getElementsByClassName("animate__animated")[0]
      .classList.add("animate__fadeOutDown");
    setTimeout(() => {
      this.dialogRef.close(value ? value : '');
    }, 500);
  }
}
